<template>
  <v-col class="shrink app-sidebar app-sidebar-right elevation-2">
    <template v-if="!showBookNowForm">
      <BookingForm
        v-if="selectedObject && selectedObject._id"
        :object="selectedObject"
        :sidebar="true"
      />
      <div>
        <ContactUsMenu
          :sidebar="true"
          :contact-options="contactOptions"
        />
      </div>
      <div v-if="selectedObject && selectedObject._id">
        <CalendarLegend :show-legend-at-the-top="true" />
        <CalendarNavigation :show-overlay="!selectedObject.calendar" />
        <CalendarNavigation
          v-if="isDesktopView && selectedObject.calendar"
          :plus-months="1"
          :show-legend="false"
          :show-overlay="!selectedObject.calendar"
        />
        <CalendarNavigation
          v-if="isDesktopView && selectedObject.calendar"
          :plus-months="2"
          :show-legend="false"
          :show-overlay="!selectedObject.calendar"
        />
        <CalendarNavigation
          v-if="isDesktopView && selectedObject.calendar"
          :plus-months="3"
          :show-legend="false"
          :show-overlay="!selectedObject.calendar"
        />
        <CalendarNavigation
          v-if="isDesktopView && selectedObject.calendar"
          :plus-months="4"
          :show-legend="false"
          :show-overlay="!selectedObject.calendar"
        />
        <CalendarNavigation
          v-if="isDesktopView && selectedObject.calendar"
          :plus-months="5"
          :show-legend="false"
          :show-overlay="!selectedObject.calendar"
        />
        <CalendarNavigation
          v-if="isDesktopView && selectedObject.calendar"
          :plus-months="6"
          :show-legend="false"
          :show-overlay="!selectedObject.calendar"
        />
        <CalendarNavigation
          v-if="isDesktopView && selectedObject.calendar"
          :plus-months="7"
          :show-legend="false"
          :show-overlay="!selectedObject.calendar"
        />
        <CalendarNavigation
          v-if="
            isDesktopView && selectedObject.calendar && selectedObject.videoLink
          "
          :plus-months="8"
          :show-legend="false"
          :show-overlay="!selectedObject.calendar"
        />
        <CalendarNavigation
          v-if="
            isDesktopView && selectedObject.calendar && selectedObject.videoLink
          "
          :plus-months="9"
          :show-legend="false"
          :show-overlay="!selectedObject.calendar"
        />
      </div>
    </template>
    <ContactBanner />
    <DynamicAutoHeightInfoBox
      v-if="showBookNowForm"
      :show-indexes="[1, 3]"
      :skip-auto-height="true"
    />
  </v-col>
</template>

<script>
import BookingForm from '@/components/Forms/BookingForm'
import ContactUsMenu from '@/components/App/Menu/ContactUsMenu'
import CalendarLegend from '@/components/Calendar/CalendarLegend'
import CalendarNavigation from '@/components/Calendar/CalendarNavigation'
import sharedComputed from '@/methods/sharedComputed'
import sharedObjectComputed from '@/methods/sharedObjectComputed'
import state from '@/store/state'
import { createHelpers } from 'vuex-map-fields'
import ContactBanner from '@/components/App/Extras/_ContactBanner'
import DynamicAutoHeightInfoBox from '@/components/App/DynamicAutoHeightInfoBox'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'ObjectRightSidebar',

  components: {
    DynamicAutoHeightInfoBox,
    ContactBanner,
    CalendarNavigation,
    CalendarLegend,
    ContactUsMenu,
    BookingForm,
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,
    ...sharedObjectComputed,
  },
}
</script>
